// ============================================
// УТИЛИТЫ ДЛЯ ОБНОВЛЕНИЯ PROMO ТЕКСТА
// ============================================

// Функция для обновления promo_text_desktop с учетом ширины экрана
function updatePromoTextDesktop(element, text) {
  if (!element || !text) return;
  
  // Сохраняем оригинальный текст
  if (!element.dataset.originalText) {
    element.dataset.originalText = text;
  }
  
  const windowWidth = window.innerWidth;
  
  if (windowWidth <= 1130) {
    // На 1130px и меньше: заменяем <br /> на пробелы
    const textWithSpaces = text.replace(/<br\s*\/?>/gi, ' ').replace(/\n/g, ' ');
    element.innerHTML = textWithSpaces;
  } else {
    // На 1131px и больше: используем <br />
    element.innerHTML = text.replace(/\n/g, '<br />');
  }
}

// Функция для обновления promo_text2 с учетом ширины экрана
function updatePromoText2(element, text) {
  if (!element || !text) return;
  
  // Сохраняем оригинальный текст
  if (!element.dataset.originalText) {
    element.dataset.originalText = text;
  }
  
  const windowWidth = window.innerWidth;
  
  if (windowWidth <= 1130) {
    // На 1130px и меньше: заменяем <br /> на пробелы
    const textWithSpaces = text.replace(/<br\s*\/?>/gi, ' ').replace(/\n/g, ' ');
    element.innerHTML = textWithSpaces;
  } else {
    // На 1131px и больше: используем <br />
    element.innerHTML = text.replace(/\n/g, '<br />');
  }
}

// Экспортируем функции глобально
window.updatePromoTextDesktop = updatePromoTextDesktop;
window.updatePromoText2 = updatePromoText2;

